const LocaleDataReference = `
  fragment LocaleDataReference on LocaleDataReference {
    displayLanguage
    label
    value
  }
`
export default LocaleDataReference
